module.exports = require('../impls/$round-robin/async-round-robin.js').asyncRoundRobin;